import { cn } from '../../lib/format.js';

/**
 * The masthead. Set in the display face at a tight tracking, with the eagle mark
 * as an inline SVG so it inherits currentColor and needs no extra request.
 */
export const Wordmark = ({ className, showMark = true }) => (
  <span className={cn('flex items-center gap-2.5 text-ink', className)}>
    {showMark && (
      <svg viewBox="0 0 24 24" className="h-full w-auto shrink-0" aria-hidden="true">
        <path d="M12 3.2 22 10v2.4L12 7.1 2 12.4V10z" fill="var(--accent)" />
        <path d="M2 15.1 12 20.8l10-5.7v2.5L12 23.3 2 17.6z" fill="currentColor" />
      </svg>
    )}
    <span className="font-display text-[15px] leading-none font-semibold tracking-[0.14em] uppercase">
      Golden Eagle
    </span>
  </span>
);

export default Wordmark;
